import { useEffect, useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Show, UserButton, useAuth } from "@clerk/react";
import { ShieldAlert } from "lucide-react";
import { useStudioApi } from "@/lib/api";
import { StudioConsole } from "@/components/studio/StudioConsole";

const Gate = () => {
  const call = useStudioApi();
  const { isLoaded } = useAuth();
  const [role, setRole] = useState(null);

  useEffect(() => {
    if (!isLoaded) return;
    call("get", "/me").then((d) => setRole(d.role)).catch(() => setRole("error"));
  }, [isLoaded, call]);

  if (!role) return <div className="min-h-screen flex items-center justify-center font-mono text-sm text-[color:var(--lr-muted)]" data-testid="studio-loading">Warming up the tubes...</div>;
  if (role !== "admin") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center" data-testid="studio-access-denied">
        <ShieldAlert className="w-12 h-12 text-[color:var(--red)]" />
        <h1 className="font-display text-5xl chrome-text">Owner only</h1>
        <p className="text-[color:var(--lr-muted)] max-w-md">The Broadcast Studio is reserved for the station owner. You can still tune in on the public player.</p>
        <div className="flex items-center gap-4">
          <Link to="/" className="rounded-full bg-[color:var(--red)] px-5 py-2 font-bold" data-testid="studio-denied-listen-link">Go listen</Link>
          <UserButton />
        </div>
      </div>
    );
  }
  return <StudioConsole />;
};

export default function Studio() {
  return (
    <>
      <Show when="signed-in"><Gate /></Show>
      <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
    </>
  );
}
